import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/services/request/request.service';
import { UtilsService } from 'src/app/services/core/utils.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-flexform-active',
  templateUrl: './flexform-active.component.html',
  styleUrls: ['./flexform-active.component.css']
})
export class FlexformActiveComponent implements OnInit {

  items = [];
  constructor(
    private requestService: RequestService,
    private title: Title,
    private utils: UtilsService
  ) { }

  ngOnInit() {
    this.title.setTitle('Relatório de Adesão FlexForm');
    this.loadPage();
  }

  loadPage() {
    this.utils.running();
    this.requestService.getFlexFormCompaniesActives()
      .then((data: []) => {
        this.items = data;
        this.utils.finish();
      });
  }

  download() {
    const headerLine = [
      'Id.',
      'Empresa',
      'Valor',
    ];
    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(this.items[0]);
    const csv = this.items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(';'));
    csv.unshift(headerLine.join(';'));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob(['\ufeff', csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = 'relatorio.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
    this.utils.finish();

  }

}
